export class StreamParseError extends Error {
  constructor(message) {
    super(message);
    this.name = "StreamParseError";
  }
}

function getFrameData(frame) {
  const dataLines = frame
    .split("\n")
    .filter((line) => line.startsWith("data:"))
    .map((line) => line.slice(5).replace(/^ /, ""));

  return dataLines.join("\n").trim();
}

function parseFrame(frame) {
  const data = getFrameData(frame);
  if (!data) {
    return null;
  }
  if (data === "[DONE]") {
    return { done: true, payload: null };
  }

  try {
    return { done: false, payload: JSON.parse(data) };
  } catch (error) {
    throw new StreamParseError("AI 返回了无法解析的流式数据");
  }
}

export async function consumeEventStream(response, onPayload) {
  if (!response.body || typeof response.body.getReader !== "function") {
    throw new StreamParseError("当前浏览器不支持流式响应");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
      buffer = buffer.replace(/\r\n/g, "\n");

      let boundaryIndex = buffer.indexOf("\n\n");
      while (boundaryIndex !== -1) {
        const frame = buffer.slice(0, boundaryIndex);
        buffer = buffer.slice(boundaryIndex + 2);

        const parsed = parseFrame(frame);
        if (parsed && parsed.done) {
          return;
        }
        if (parsed) {
          await onPayload(parsed.payload);
        }

        boundaryIndex = buffer.indexOf("\n\n");
      }

      if (done) {
        break;
      }
    }

    const finalFrame = buffer.trim();
    if (finalFrame) {
      const parsed = parseFrame(finalFrame);
      if (parsed && !parsed.done) {
        await onPayload(parsed.payload);
      }
    }
  } finally {
    reader.releaseLock();
  }
}
